import { useSelector, shallowEqual } from 'react-redux';

import { selectAccount as selectEmployeeDetails } from 'state/azure-active-directory/aad-slice';
import { useIsLoginEnabledJourney } from 'hooks/useIsLoginEnabledJourney';

export const useEmployee = () => {
  const aadEmpolyee = useSelector(selectEmployeeDetails, shallowEqual) || {};

  const isLoginEnabledJourney = useIsLoginEnabledJourney();
  const salesAgentCode = isLoginEnabledJourney
    ? aadEmpolyee.employeeId
    : undefined;

  return {
    salesAgentCode
  };
};
